import styled from 'styled-components';

export const CaptchaImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;